export default __webpack_public_path__ + "static/media/logo-invision.f3413d25.svg";